import { ComponentPropsWithoutRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

interface IInputRHFV2Props extends ComponentPropsWithoutRef<"input"> {
  label?: string;
}

export const InputRHFV2 = forwardRef<HTMLInputElement, IInputRHFV2Props>(
  ({ label, className, id, ...rest }, ref) => {
    return (
      <div className="relative w-full">
        {label && (
          <label
            htmlFor={id}
            className="absolute -top-[9px] left-4 z-10 flex bg-gradient-to-t from-white from-50% to-transparent to-50% px-1 text-xs text-[#2d2d2d]"
          >
            {label}
          </label>
        )}

        <input
          {...rest}
          id={id}
          ref={ref}
          className={twMerge(
            "h-11 w-full rounded-lg border border-solid border-[#2d2d2d] bg-white pl-3.5 pr-3.5 font-['Mulish'] text-base font-normal text-[#2d2d2d] placeholder:text-[#9d9d9d] read-only:text-[#2d2d2d] focus:outline-none",
            className,
          )}
        />
      </div>
    );
  },
);

InputRHFV2.displayName = "InputRHFV2";
